import { useNavigate } from 'react-router-dom';
import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Modal, message as Message, notification as Notification, Dropdown, Button } from 'antd';

// Redux
import { useAppSelector } from '../../../../../../store/store';

// Services
import { deleteSubsidio } from '../../../../../../services/subsidios.service';

// Constants
import { ROUTES } from '../../../../../../constants/routes-constants';

// Interfaces
import type { MenuProps } from 'antd';

export const SubsidioActionsMenu = () => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user!);
  const subsidio = useAppSelector((state) => state.subsidioDetalle.subsidio!);
  const cooperativa = subsidio?.cooperativa;

  const items: MenuProps['items'] = [];
  const [modal, modalContext] = Modal.useModal();
  const [notification, notificationContext] = Notification.useNotification();

  if (!subsidio) return null;

  if (user.permissions.includes('delete_subsidios')) {
    items.push({
      key: '1',
      icon: <DeleteOutlined />,
      label: 'Eliminar subsidio',
      onClick: () =>
        modal.confirm({
          width: 600,
          centered: true,
          title: '¿Está seguro que desea eliminar este subsidio?',
          content: 'Esta acción no se puede deshacer.',
          okText: 'Sí, eliminar',
          okType: 'danger',
          okButtonProps: { type: 'primary' },
          cancelText: 'Cancelar',
          onOk: async () => {
            return deleteSubsidio(subsidio.id)
              .then(() => {
                Message.success('Subsidio eliminado con éxito.');
                navigate(
                  ROUTES.COOPERATIVAS_DETAILS.replace(':id', `${cooperativa.id}`) +
                    '?seccion=subsidios'
                );
              })
              .catch((error) => {
                notification.error({
                  message: 'Error',
                  placement: 'bottomRight',
                  description:
                    error?.response?.data?.message ||
                    'Ocurrió un error inesperado al intentar eliminar el subsidio.'
                });
              });
          }
        })
    });
  }

  return items.length ? (
    <>
      {modalContext}
      {notificationContext}
      <Dropdown menu={{ items }} placement="bottomLeft">
        <Button icon={<DownOutlined />} shape="round">
          Acciones
        </Button>
      </Dropdown>
    </>
  ) : null;
};
